import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appRoleInput]',
    standalone: false
})
export class RoleInputDirective implements OnInit {
  @Input('appRoleInput') roles: string[]; // Accept roles as input
  // roles = "support,key,factory-supervisor,line-supervisor,production-admin"; //these roles have all tha access rest other restricted
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const userRole = localStorage.getItem('userRole'); // Assuming you have a method to get the user role 
    if (!this.roles.includes(userRole)) {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
      this.renderer.addClass(this.el.nativeElement, 'blurred');
    }
  }

}
